<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      title="订单筛选"
      custom-class="select-people-dialog"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1050px"
    >
      <el-form :model="orderFormName" :rules="rules" ref="ruleForm" :disabled="isReadOnly" :label-width="formLabelWidth">
        <el-form-item label="节点名称" prop="name">
          <el-input v-model="orderFormName.name" autocomplete="off" :maxlength="50"></el-input>
          <span class="nameTips" style="color:#627085">{{ getNameLength }}/50</span>
        </el-form-item>
        <el-form-item label="订单时间">
          <el-select v-model="orderForm.orderTimeType" style="margin-right: 10px;">
            <el-option label="下单时间" value="ORDER"></el-option>
            <el-option label="付款时间" value="PAY"></el-option>
            <el-option label="完成时间" value="FIN"></el-option>
          </el-select>
          <el-select v-model="orderForm.timeType" style="margin-right: 10px;">
            <el-option label="绝对时间" :value="2"></el-option>
            <el-option label="相对时间" :value="1"></el-option>
          </el-select>
          <el-date-picker
            v-model="orderForm.orderTimeArr"
            v-if="orderForm.timeType == 2"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <span v-else>
            <el-input
              v-model="orderForm.orderStartTime"
              placeholder="天"
              size="small"
              style="width: 125px;margin-left:20px;"
              maxlength="15"
              class="color_gray"
              type="number"
              @change="
                changeOrderTime(orderForm.orderStartTime, orderForm.orderEndTime, (val) => {
                  orderForm.orderStartTime = val;
                })
              "
            >
            </el-input>
            <span style="margin:0 10px;">-</span>
            <el-input
              v-model="orderForm.orderEndTime"
              placeholder="天"
              size="small"
              style="width: 125px"
              maxlength="15"
              class="color_gray"
              type="number"
              @change="
                changeOrderTime(orderForm.orderStartTime, orderForm.orderEndTime, (val) => {
                  orderForm.orderEndTime = val;
                })
              "
            >
            </el-input>
          </span>
        </el-form-item>
        <el-form-item label="订单金额" style="height:33px;">
          <el-radio-group v-model="orderForm.orderPaymentType">
            <el-radio :label="1">不限</el-radio>
            <el-radio :label="2">1~100元</el-radio>
            <el-radio :label="3">100~200元</el-radio>
            <el-radio :label="4">200~300元</el-radio>
            <el-radio :label="5">300元以上</el-radio>
            <el-radio :label="6">自定义</el-radio>
          </el-radio-group>
          <span v-show="orderForm.orderPaymentType == 6">
            <el-input
              v-model="orderForm.orderPaymentStart"
              placeholder="不限"
              size="small"
              style="width: 125px;margin-left:20px;"
              maxlength="15"
              class="color_gray"
              type="number"
              @change="
                changeOrderTime(orderForm.orderPaymentStart, orderForm.orderPaymentEnd, (val) => {
                  orderForm.orderPaymentEnd = val;
                })
              "
            >
              <template slot="suffix">
                <span>元</span>
              </template>
            </el-input>
            <span style="margin:0 10px;">-</span>
            <el-input
              v-model="orderForm.orderPaymentEnd"
              placeholder="不限"
              size="small"
              style="width: 125px"
              maxlength="15"
              class="color_gray"
              type="number"
              @change="
                changeOrderTime(orderForm.orderPaymentStart, orderForm.orderPaymentEnd, (val) => {
                  orderForm.orderPaymentEnd = val;
                })
              "
            >
              <template slot="suffix">
                <span>元</span>
              </template>
            </el-input>
          </span>

          <div style="color:red;margin-top: -10px;">注意：pop为实付金额，由于接口限制自营为订单金额非实付金额</div>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-checkbox-group
            v-model="orderForm.payTypeArr"
            @change="
              (v) => {
                return changeCheckBox(v, 'payTypeArr');
              }
            "
          >
            <el-checkbox label>不限</el-checkbox>
            <el-checkbox label="1">货到付款</el-checkbox>
            <el-checkbox label="2">邮局汇款</el-checkbox>
            <el-checkbox label="3">自提</el-checkbox>
            <el-checkbox label="4">在线支付</el-checkbox>
            <el-checkbox label="5">公司转账</el-checkbox>
            <el-checkbox label="6">银行转账</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-checkbox-group
            v-model="orderForm.orderStateArr"
            @change="
              (v) => {
                return changeCheckBox(v, 'orderStateArr');
              }
            "
          >
            <el-checkbox label>不限</el-checkbox>
            <el-checkbox label="WAIT_PAYMENT">未付款订单</el-checkbox>
            <el-checkbox label="WAIT_SELLER_STOCK_OUT">等待出库</el-checkbox>
            <el-checkbox label="WAIT_GOODS_RECEIVE_CONFIRM">等待确认收货</el-checkbox>
            <el-checkbox label="FINISHED_L">完成订单</el-checkbox>
            <el-checkbox label="TRADE_CANCELED">取消订单</el-checkbox>
            <el-checkbox label="LOCKED">退货订单</el-checkbox>
            <el-checkbox label="PAUSE">暂停订单</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择商品">
          <div style="width: 420px;">
            <el-radio-group v-model="orderForm.wareFilterType">
              <el-radio :label="1">全部商品</el-radio>
              <el-radio :label="2"> 指定商品</el-radio>
              <el-radio :label="3"> 排除商品</el-radio>
            </el-radio-group>
            <div class="button" @click="handleShowGoods(true)" style="margin-left:10px;" v-show="orderForm.wareFilterType != 1">
              已选择
              <span>{{ goodsStateLength }}</span>
              个
            </div>
          </div>
        </el-form-item>
        <el-form-item label="选择地区">
          <div class="bb" style="width: 570px">
            <el-radio
              v-model="orderForm.appointAreaType"
              v-for="item in areaData"
              :key="item.value"
              :label="item.value"
              @change="customArea(item.value)"
            >
              <span>{{ item.name }}</span>
            </el-radio>
            <div class="button" @click="popupShowBtn" v-show="orderForm.appointAreaType == '3'">
              已选择
              <span>{{ checkedList | getCityLength }}</span>
              个
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;">
        <div>
          <el-button type="primary" :disabled="isReadOnly" @click="orderSubmit(0)">查询人数</el-button>
          <span style="margin:0 10px;"
            >预计人数：
            <span v-if="!isSearchCrowd">{{ people }}</span>
            <i v-else class="el-icon-loading"></i>
          </span>
          <span><el-checkbox v-model="isBuildCrow">同时生成人群包</el-checkbox></span>
        </div>
        <div>
          <el-button @click="viewVisible = false">取 消</el-button>
          <el-button type="primary" :disabled="isReadOnly" @click="orderSubmit(1)">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 自定义城市弹窗 -->
    <city-popover v-model="areaState" :checkedList="checkedList" :isProvince="true" @on-change="changeCity"></city-popover>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsStateFirst"
      :isShow="goodsState"
      :moduleType="true"
      :skuSearch="venderType ? true : false"
      :selectGoods="returnSelectGoods"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="true"
      @close="selectGoodsChange"
    ></select-goods>
  </div>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
import CityPopover from "@/components/city-popover-x";
import selectGoods from "@/components/selectGoodsMonitor";
const JZH_CODE = [
  {
    code: "9",
    city: "黄浦区,卢湾区,徐汇区,长宁区,静安区,闸北区,虹口区,杨浦区,宝山区,闵行区,嘉定区,浦东新区,青浦区,松江区,金山区,南汇区,奉贤区,普陀区,崇明区",
  },
  { code: "10", city: "南京市,无锡市,徐州市,常州市,苏州市,南通市,连云港市,淮安市,盐城市,扬州市,镇江市,泰州市,宿迁市,吴江市,宜兴市" },
  { code: "11", city: "杭州市,宁波市,温州市,嘉兴市,湖州市,绍兴市,金华市,衢州市,舟山市,台州市,丽水市" },
];

const PY_CODE = [
  { code: "5", city: "呼和浩特市,包头市,乌海市,赤峰市,通辽市,鄂尔多斯市,呼伦贝尔市,巴彦淖尔市,乌兰察布市,兴安盟,锡林郭乐盟,阿拉善盟,哲里木盟" },
  {
    code: "25",
    city: "昆明市,玉溪市,曲靖市,昭通市,红河州,文山州,西双版纳州,大理州,怒江州,丽江市,迪庆藏族自治县,楚雄州,临沧市,保山市,德宏州,普洱市,迪庆州",
  },
  { code: "26", city: "拉萨市,那曲地区,昌都地区,山南地区,日喀则地区,阿里地区,林芝市" },
  { code: "29", city: "西宁市,海东地区,海北州,黄南州,海南州,果洛州,玉树州,海西州" },
  {
    code: "31",
    city:
      "乌鲁木齐市,克拉玛依市,吐鲁番地区,哈密地区,和田地区,阿克苏地区,喀什地区,克孜勒苏柯尔克孜自治州,巴音郭楞州,昌吉州,博尔塔拉州,伊犁州,石河子市,阿拉尔市,图木舒克市,五家渠市,塔城地区,阿勒泰地区,奎屯市,新疆维吾尔自治区,铁门关市,昆玉市",
  },
];
export default {
  /*  选择人群弹窗 */
  name: "order-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    peopleList: {
      type: Array,
      default: () => [],
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CityPopover,
    selectGoods,
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
    getNameLength: function() {
      return this.orderFormName.name.length;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  data() {
    return {
      goodsStateFirst:false,
      areaState: false,
      goodsState: false,
      venderQuanxian: this.$store.state.loginUserInfo.venderType,
      orderFormName: {
        name: "",
      },
      orderForm: {
        timeType: 2,
        orderTimeType: "ORDER",
        orderPaymentType: 1,
        wareFilterType: 1,
        appointAreaType: 0,
        payTypeArr: [""],
        orderStateArr: [""],
        orderTimeArr: [],
        wareList: [],
      },
      isBuildCrow: true,
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          { min: 1, max:50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
      },
      formLabelWidth: "80px",
      checkedList: [],
      returnSelectGoods: [],
      selectGoodsSkuList: [],
      areaData: [
        {
          value: 0,
          name: "全部",
        },
        {
          value: 1,
          name: "江浙沪",
        },
        {
          value: 2,
          name: "偏远地区（疆藏云海蒙）",
        },
        {
          value: 3,
          name: "自定义",
        },
      ],
      goodsStateLength1: 0,
      goodsStateLength: 0,
      goodsStateLength2: 0,
      people: 0,
      isSearchCrowd: false,
    };
  },
  created() {
    //双击节点，调取接口，获取节点输入框的名字
    mnode.getNode({ nodeId: this.nodeId }).then((res) => {
      if (res.code === 1 && res.data.name) {
        this.orderFormName.name = res.data.name;
        if (res.data.isBuildCrow == null) {
          this.isBuildCrow = true;
        } else {
          this.isBuildCrow = res.data.isBuildCrow;
        }
        var obj = res.data.orderNode;
        if (obj.orderState) {
          obj.orderStateArr = obj.orderState.split(",");
        } else {
          obj.orderStateArr = [""];
        }
        if (obj.payType) {
          obj.payTypeArr = obj.payType.split(",");
        } else {
          obj.payTypeArr = [""];
        }
        if (obj.timeType == 2) {
          obj.orderTimeArr = [obj.orderStartTime ? obj.orderStartTime : "", obj.orderEndTime ? obj.orderEndTime : ""];
        }
        // this.goodsStateLength = obj.wareList.length

        if (this.venderQuanxian) {
          this.returnSelectGoods = obj.wareList;
          this.selectGoodsSkuList = obj.wareList;
          // this.selectGoodsChange(this.selectGoodsSkuList,[])
        } else {
          obj.wareList.forEach((e) => {
            if (e.wareId) {
              this.returnSelectGoods.push(e);
            } else {
              this.selectGoodsSkuList.push(e);
            }
          });
        }
        this.selectGoodsChange(this.returnSelectGoods, this.selectGoodsSkuList);
        if (obj.appointAreaType == 3) {
          this.checkedList = obj.cityList;
        }
        this.orderForm = obj;
      }
    });
  },
  methods: {
    changeOrderTime(val1, val2, callback) {
      if (Number(val1) > Number(val2)) {
        this.$message.warning("起始值不得大于结束值");
        // this.orderForm[key] = ''
        callback("");
      }
    },
    changeCheckBox(v, arr) {
      if (v[v.length - 1] === "" || v.length === 0) {
        this.orderForm[arr] = [""];
        return;
      }
      for (let i = 0; i < v.length; i++) {
        if (v.length >= 2 && v[i] == "") {
          this.orderForm[arr].splice(i, 1);
        }
      }
    },
    handleClose() {
      this.viewVisible = false;
    },
    // 保存参数设置
    orderSubmit(type) {
      if (!this.orderFormName.name && type == 1) {
        return this.$message.warning("请输入节点名称");
      } else if (this.orderForm.timeType == 1 && this.orderForm.orderStartTime && this.orderForm.orderEndTime) {
        if (Number(this.orderForm.orderStartTime) > Number(this.orderForm.orderEndTime)) {
          return this.$message.warning("请输入正确的订单时间");
        }
      } else if (this.orderForm.orderPaymentType && this.orderForm.orderPaymentStart && this.orderForm.orderPaymentEnd) {
        if (+this.orderForm.orderPaymentStart > +this.orderForm.orderPaymentEnd) {
          return this.$message.warning("请输入正确的订单金额");
        }
      }
      var obj = {
        ...this.orderForm,
        payType: this.orderForm.payTypeArr.join(","),
        orderState: this.orderForm.orderStateArr.join(","),
        wareList: this.orderForm.wareList,
      };
      if (this.orderForm.appointAreaType == 1) {
        obj.cityList = JZH_CODE;
      } else if (this.orderForm.appointAreaType == 2) {
        obj.cityList = PY_CODE;
      } else if (this.orderForm.appointAreaType == 3) {
        obj.cityList = this.checkedList;
      } else {
        obj.cityList = [];
      }
      if (this.orderForm.timeType == 2) {
        if (this.orderForm.orderTimeArr) {
          obj.orderStartTime = this.orderForm.orderTimeArr[0];
          obj.orderEndTime = this.orderForm.orderTimeArr[1];
        } else {
          obj.orderStartTime = "";
          obj.orderEndTime = "";
        }
      }
      if (obj.orderPaymentType != 6) {
        obj.orderPaymentStart = "";
        obj.orderPaymentEnd = "";
      }
      if (obj.wareFilterType == 1) {
        obj.wareList = [];
      }
      delete obj.orderStateArr;
      delete obj.payTypeArr;
      delete obj.orderTimeArr;
      if (type == 1) {
        this.sendSave(obj);
      } else {
        this.searchPeople(obj);
      }
    },
    //获取数据
    getDataify() {
      let formData = {};
      formData.nodeId = this.$props.nodeId;
      formData.name = this.orderFormName.name;
      return formData;
    },
    // 点击确定
    sendSave(obj) {
      var item = {
        orderNode: obj,
        name: this.orderFormName.name,
        nodeId: this.nodeId,
        isBuildCrow: this.isBuildCrow,
      };
      let data = this.getDataify();
      mnode.updateDetail(item).then((res) => {
        if (res.code == 1) {
          this.viewVisible = false;
          this.$message.success(res.message);
          this.$emit("change-name", data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 查询人数
    searchPeople(obj) {
      this.isSearchCrowd = true;
      mnode
        .orderCount(obj)
        .then((res) => {
          this.people = res.data;
          this.isSearchCrowd = false;
        })
        .catch((err) => {
          this.isSearchCrowd = false;
        });
    },
    changeCity(arr, type) {
      if (type == "cancel") {
        return;
      }
      console.log(arr);
      arr.forEach((e) => {
        if (e.code == "31") {
          console.log(e.city);
        }
      });
      this.checkedList = arr;
    },
    //自定义地区
    customArea(v) {
      if (v == 3) {
        this.popupShowBtn();
        return;
      }
    },
    /*
     *  自定义显示
     *
     * */
    popupShowBtn() {
      this.orderForm.appointAreaType = 3;
      this.areaState = true;
    },
    handleShowGoods() {
      this.goodsState = true;
      this.goodsStateFirst = true
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      return [...new Set([...listArr, ...listArr1])];
    },
    // 指定商品
    selectGoodsChange(val, item) {
      this.goodsState = false;
      console.log(val, item, 11);
      if (val || item) {
        // 数据缓存到指定商品数组

        if (!this.venderQuanxian) {
          let skuArr = [];
          val.forEach((i) => {
            // delete i.skuId
            if (i.skuList != 0) {
              i.skuList.forEach((ele) => {
                if (ele.skuId) {
                  skuArr.push(ele.skuId);
                } else {
                  skuArr.push(ele);
                }
              });
            }
          });
          let skuArr1 = item.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr, skuArr1).length;
          this.selectGoodsSkuList = item;
        } else {
          this.goodsStateLength = val.length;
        }
        if(item == null){
          item = []
        }
        this.orderForm.wareList = [...val, ...item];
        this.returnSelectGoods = val;
        console.log(this.orderForm.wareList, this.returnSelectGoods, 111);
      }
    },
  },
  filters: {
    getCityLength(list) {
      var length = 0;
      if (list && list.length > 0) {
        list.forEach((item) => {
          if (item.city) {
            length += item.city.split(",").length;
          }
        });
      }
      return length;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__body-wrapper {
  height: 345px;
  overflow-y: auto;
}

// 选择人群弹窗
.select-people-dialog {
  .table-box {
    max-height: 400px;
    overflow: auto;
  }
  .dialog-title {
    span {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
      .el-button {
        font-size: 14px;
      }
    }
  }
  .search-line {
    margin-bottom: 24px;
    .el-input {
      width: 280px;
      margin-right: 20px;
    }
  }
  .button-group {
    display: inline-block;
    .search {
      width: 98px;
      height: 32px;
      color: #fe4d45;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #dddddd;

      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .dialog-footer-btn {
    text-align: center;
    margin-top: 30px;
    .search {
      width: 98px;
      height: 32px;
      color: #ffffff;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      margin: 0px 0px 0 800px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .btn_create {
    color: #7f85e9;
    float: right;
    width: 98px;
    height: 28px;
    display: flex;
    align-items: center;
    // line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    cursor: pointer;
  }
  .button {
    // width: 103px;
    // height: 30px;
    // background: rgba(255, 255, 255, 1);
    // border: 1px solid rgba(209, 210, 217, 1);
    opacity: 1;
    // border-radius: 2px;
    text-align: center;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    display: block;
    float: right;
    cursor: pointer;
    border-radius: 3px;
    padding: 0 10px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;
    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
</style>
